<template>
  <div class="performance-dialogue">
    <div v-if="!selectedIndex || selectedIndex == 0">
      <div class="input-label-gray flex-center flex-wrap max-profit-loss-section" style="font-size: 12px; border-radius: 5px; margin-bottom: 15px; width: 100%">
        <div class="profit-loss-blocks" style="background: #edfbf2; border-radius: 5px 0 0 5px">
          <span class="left-margin-10">Max Upside:</span>
          <span style="color: #079e3e; font-weight: 600; font-size: 13px" v-if="segment == 'Equity'">
            <span style="margin-left: 2px">{{ selectedRecommendation.max_profit_in_percentage }}%</span>
          </span>

          <span style="color: #079e3e; font-weight: 600; font-size: 13px" v-else>
            <span style="margin-left: 2px">{{ strategyData.max_profit_in_percentage }}%</span>
          </span>
        </div>
        <div class="profit-loss-blocks" style="background: #fff4f4; border-radius: 0 5px 5px 0">
          <span class="left-margin-10">Max Downside:</span>
          <span class="circle" style="font-weight: 600; color: red; font-size: 13px" v-if="segment == 'Equity'">
            <span style="margin-left: 2px">{{ selectedRecommendation.max_loss_in_percentage }}%</span>
          </span>

          <span class="circle" style="font-weight: 600; color: red; font-size: 13px" v-else>
            <span style="margin-left: 2px">{{ strategyData.max_loss_in_percentage }}%</span>
          </span>
        </div>
      </div>

      <div class="input-label-gray flex-center" v-if="strategyData && strategyData.capitalRequired">
        <span class="capital-req-box">
          <span>Approx Capital Required :</span>
          <span style="color: #30313f; font-weight: 600; width: 13px">₹ {{ strategyData.capitalRequired }}</span>
        </span>
        <el-popover placement="bottom" width="200" trigger="click">
          <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; position: relative; top: 1px" alt slot="reference" />

          <div>
            <div style="font-size: 12px; font-weight: 600; color: #079e3e">Buying</div>
            <div class="bottom-margin-15">Capital required is calculated on basis of LTP</div>

            <div style="font-size: 12px; font-weight: 600; color: red">Selling</div>
            <div>Capital required is approximate value & calculated on basis of investment of lot size 1</div>
          </div>
        </el-popover>
      </div>
    </div>

    <div class="progress-bar-inner" >
      <div v-if="segment == 'Equity' && selectedRecommendation.stock">
        <div class="input-label-gray flex-space-between" style="font-size: 12px; margin-bottom: 5px">
          <div>
            <span>Status :</span>
            <span
              style="font-weight: 600"
              :style="[
                selectedRecommendation.reco_status == 'LIVE' || selectedRecommendation.reco_status == 'UPDATED' || selectedRecommendation.reco_status == 'TARGET ACHIEVED'
                  ? {
                      color: '#079e3e',
                    }
                  : {
                      color: '#000',
                    },
              ]"
            >
              <!-- {{ selectedRecommendation.reco_status }} -->
              {{ selectedRecommendation.reco_status ? selectedRecommendation.reco_status.replace(/_/g, ' ') : '' }}
            </span>
          </div>
          <div>
            <span>Reco Type :</span>
            <span
              class="circle"
              style="font-weight: 600"
              :style="[
                selectedRecommendation.reco == 'Buy'
                  ? {
                      color: '#079e3e',
                    }
                  : {
                      color: 'red',
                    },
              ]"
            >
              {{ selectedRecommendation.reco.toUpperCase() }}
            </span>
          </div>
        </div>
      </div>

      <div v-else class="flex-space-between top-margin-5" style="align-items: baseline">
        <div v-if="strategyData">
          <div class="stock-title bottom-margin-5" v-if="selectedRecommendation.stock && strategyData.legLength > 1">
            {{ selectedRecommendation.stock.title }}
            {{ moment(selectedRecommendation.stock.expiry).format('D MMM YY' + "'") }}
            {{ selectedRecommendation.stock.strike }}
            {{ selectedRecommendation.stock.instrument_type }}
          </div>

          <div class="input-label-bold-gray" style="font-size: 12px; margin: 0 !important">
            <span>Status :</span>
            <span
              class="stock-title"
              :style="[
                selectedRecommendation.status == 'LIVE' || selectedRecommendation.status == 'COMPLETE' || selectedRecommendation.status == 'TARGET_ACHIEVED'
                  ? {
                      color: '#079e3e',
                    }
                  : selectedRecommendation.status == 'STOPLOSS_TRIGGERED' || selectedRecommendation.status == 'TARGET NOT ACHIEVED'
                  ? {
                      color: 'red',
                    }
                  : {
                      color: '#878787',
                    },
              ]"
            >
              <!-- {{ selectedRecommendation.status }} -->
              {{ selectedRecommendation.status ? selectedRecommendation.status.replace(/_/g, ' ') : '' }}
            </span>
          </div>
          <div class="input-label-bold-gray" style="font-size: 12px; margin-top: 0">
            Lot Size :
            <span>{{ selectedRecommendation.quantity }}</span>
          </div>
        </div>
        <div class="text-right">
          <div class="flex top-margin-20 text-center">
            <el-button class="buy-sell-btn" :class="selectedRecommendation.direction == 'SELL' ? 'act-period-type-tag-red' : 'act-period-type-tag'" style="margin: 0" v-on:click="goToTradePage(strategyData.strategy, selectedIndex)" v-if="userProfile && !currentEnvironment.byPassLogin && !currentEnvironment.isStockAntsAuth && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'BlinkX' && userProfile.utm_source != 'AngelOne' && userProfile.utm_source != '5 Paisa' && userProfile.utm_source != 'Dhan' && userProfile.utm_source != 'Finvasia' && userProfile.utm_source != 'Zerodha'">
              <img style="width: 12px; margin-right: 2px; position: relative; top: 2px" src="../assets/images/two-arrows.png" alt="" />
              {{ selectedRecommendation.direction }}
            </el-button>

            <el-button v-else-if="currentEnvironment.byPassLogin && currentEnvironment.isHybridModel" :class="selectedRecommendation.direction == 'SELL' ? 'act-period-type-tag-red' : 'act-period-type-tag'" class="buy-sell-btn" style="margin: 0" v-on:click="getTradeHostDetails()">
              <img style="width: 12px; margin-right: 2px; position: relative; top: 2px" src="../assets/images/two-arrows.png" alt="" />
              {{ selectedRecommendation.direction }}
            </el-button>

            <el-button v-else class="buy-sell-btn" :class="selectedRecommendation.direction == 'SELL' ? 'act-period-type-tag-red' : 'act-period-type-tag'" style="margin: 0" v-on:click="userProfile && userProfile.utm_source == 'BlinkX' ? openLeaveConfirmationPopup() : ''">{{ selectedRecommendation.direction }}</el-button>
          </div>
        </div>
      </div>

      <div class="progress-bar" v-loading="progressBarLoading" v-if="selectedRecommendation.reco_status == 'YET TO LIVE' || selectedRecommendation.status == 'YET_TO_LIVE'">
        <div class="inner-progress-bar">
          <div class="left-outer">
            <div class="left-point"></div>
            <div class="input-label-gray top-margin-10">Stop Loss</div>
            <div class="input-label-gray" style="color: red; font-size: 12px">
              {{ selectedRecommendation.stop_loss ? '₹ ' + selectedRecommendation.stop_loss : '' }}
            </div>
          </div>
          <div class="entry-point">
            <div style="width: 100px; margin-top: 30px">
              <div class="entry-point-position-mobile">
                <div class="input-label-gray">Entry</div>
                <div class="input-label-gray" style="color: #000; font-size: 12px">
                  <span v-if="segment == 'Options'">
                    {{ selectedRecommendation.entry_premium ? '₹ ' + selectedRecommendation.entry_premium : '' }}
                  </span>
                  <span v-else>
                    {{ selectedRecommendation.reco_open_price ? '₹ ' + selectedRecommendation.reco_open_price : '' }}
                  </span>
                </div>
                <div class="input-label-gray-small">{{ entryDateTime | filterTime }},</div>
                <div class="input-label-gray-small">
                  {{ entryDateTime | formatDate }}
                </div>
              </div>
            </div>
          </div>
          <div class="right-outer">
            <div class="right-point"></div>
            <div class="input-label-gray top-margin-10">Target</div>
            <div class="input-label-gray" style="color: #079e3e; font-size: 12px">
              <span v-if="segment == 'Options'">
                {{ selectedRecommendation.target_premium ? '₹ ' + selectedRecommendation.target_premium : '' }}
              </span>
              <span v-else>
                {{ selectedRecommendation.target_price ? '₹ ' + selectedRecommendation.target_price : '' }}
              </span>
            </div>
            <div class="input-label-gray-small">
              {{ targetDateTime | formatDate }}
            </div>
          </div>
        </div>
      </div>

      <div class="progress-bar" v-loading="progressBarLoading" v-else>
        <div class="inner-progress-bar">
          <div class="left-outer">
            <div class="left-point"></div>
            <div class="input-label-gray top-margin-10">Stop Loss</div>
            <div class="input-label-gray" style="color: red; font-size: 12px" v-if="selectedRecommendation.stop_loss">₹ {{ selectedRecommendation.stop_loss }}</div>

            <!-- Section for stop_loss_triggered_timestamp for equity-->
            <div v-if="selectedRecommendation.stop_loss_triggered_date_time">
              <div class="input-label-gray-small">
                {{ selectedRecommendation.stop_loss_triggered_date_time | filterTime }}
              </div>
              <div class="input-label-gray-small">
                {{ selectedRecommendation.stop_loss_triggered_date_time | formatDate }}
              </div>
            </div>

            <!-- Section for stop_loss_hit_timestamp for options-->
            <div v-if="selectedRecommendation.stop_loss_hit_timestamp">
              <div class="input-label-gray-small">
                {{ selectedRecommendation.stop_loss_hit_timestamp | filterTime }}
              </div>
              <div class="input-label-gray-small">
                {{ selectedRecommendation.stop_loss_hit_timestamp | formatDate }}
              </div>
            </div>
          </div>
          <div>
            <!-- Profit Section -->
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content" class="text-center">
                Performance
                <br />
                {{ selectedRecommendation.performance ? selectedRecommendation.performance + '%' : '' }}
              </div>
              <div :id="'profit' + selectedRecommendation.id" class="profit">
                <div class="top-section" v-if="selectedRecommendation.target_not_achieved_date_time || selectedRecommendation.target_not_hit_timestamp">
                  <!-- <div>LTP</div> -->
                  <!-- <div> -->
                  <!-- Section for target_not_achieved_date_time for equity-->
                  <!-- <div
                      v-if="
                        selectedRecommendation.target_not_achieved_date_time
                      "
                    >
                      <div class="input-label-gray-small">
                        {{
                          selectedRecommendation.target_not_achieved_date_time
                            | filterTime
                        }}
                      </div>
                      <div class="input-label-gray-small">
                        {{
                          selectedRecommendation.target_not_achieved_date_time
                            | formatDate
                        }}
                      </div>
                    </div> -->

                  <!-- Section for target_not_hit_timestamp for options-->
                  <!-- <div v-if="selectedRecommendation.target_not_hit_timestamp">
                      <div class="input-label-gray-small">
                        {{
                          selectedRecommendation.target_not_hit_timestamp
                            | filterTime
                        }}
                      </div>
                      <div class="input-label-gray-small">
                        {{
                          selectedRecommendation.target_not_hit_timestamp
                            | formatDate
                        }}
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </el-tooltip>
            <!-- CMP section -->
            <div style="position: absolute; bottom: 2px; text-align: left; left: 19%" :id="'cmp-position' + selectedRecommendation.id">
              <div v-if="selectedRecommendation.status == 'LIVE' || selectedRecommendation.status == 'UPDATED' || selectedRecommendation.status == 'EXIT' || selectedRecommendation.reco_status == 'LIVE' || selectedRecommendation.reco_status == 'EXIT' || selectedRecommendation.status == 'TARGET_NOT_ACHIEVED' || selectedRecommendation.reco_status == 'TARGET NOT ACHIEVED' || selectedRecommendation.reco_status == 'UPDATED'">
                <div class="input-label-gray top-margin-5">
                  {{ selectedRecommendation.reco_status == 'EXIT' || selectedRecommendation.status == 'EXIT' ? 'Exit Price' : selectedRecommendation.reco_status == 'TARGET NOT ACHIEVED' || selectedRecommendation.status == 'TARGET_NOT_ACHIEVED' ? 'LTP' : 'CMP' }}
                </div>
                <div class="input-label-gray" style="color: #2d2e8d; font-size: 12px">
                  <span v-if="segment == 'Options'">
                    {{ selectedRecommendation.status == 'EXIT' || selectedRecommendation.status == 'TARGET_NOT_ACHIEVED' ? '₹' + selectedRecommendation.status_action_price.toFixed(2) : selectedRecommendation.status == 'TARGET NOT ACHIEVED' ? '₹' + selectedRecommendation.target_not_achieved_date_time.toFixed(2) : '₹' + selectedRecommendation.current_premium.toFixed(2) }}
                  </span>
                  <span v-else>
                    {{ selectedRecommendation.reco_status == 'EXIT' ? '₹' + selectedRecommendation.exit_price.toFixed(2) : selectedRecommendation.reco_status == 'TARGET NOT ACHIEVED' ? '₹' + selectedRecommendation.target_not_achieved_price.toFixed(2) : '₹' + selectedRecommendation.stock.current_price.toFixed(2) }}
                  </span>
                </div>

                <div class="input-label-gray-small" style="width: 60px">
                  {{ cmpDateTime | filterTime }},
                  {{ cmpDateTime | formatDate }}
                </div>
                <!-- <div class="input-label-gray">{{ cmpDateTime | formatDate }}</div> -->

                <i class="el-icon-caret-bottom" style="color: #2d2e8d"></i>
              </div>
              <div v-else style="height: 50px"></div>
            </div>

            <!-- loss Section -->
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content" class="text-center">
                Performance
                <br />
                {{ selectedRecommendation.performance ? selectedRecommendation.performance + '%' : '' }}
              </div>

              <div :id="'loss' + selectedRecommendation.id" class="loss"></div>
            </el-tooltip>

            <div class="entry-point">
              <div style="width: 100px; margin-top: 25px">
                <div class="entry-point-position-mobile">
                  <div class="input-label-gray">Entry</div>
                  <div class="input-label-gray" style="color: #000; font-size: 12px">
                    <span v-if="segment == 'Options'">
                      {{ selectedRecommendation.entry_premium ? '₹ ' + selectedRecommendation.entry_premium : '' }}
                    </span>
                    <span v-else>
                      {{ selectedRecommendation.reco_open_price ? '₹ ' + selectedRecommendation.reco_open_price : '' }}
                    </span>
                  </div>
                  <div class="input-label-gray-small">{{ entryDateTime | filterTime }},</div>
                  <div class="input-label-gray-small">
                    {{ entryDateTime | formatDate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-outer">
            <div class="right-point"></div>
            <div class="input-label-gray top-margin-10">
              {{ selectedRecommendation.status == 'TARGET_ACHIEVED' || selectedRecommendation.reco_status == 'TARGET ACHIEVED' ? 'Target Achieved at' : 'Target' }}
            </div>
            <div class="input-label-gray" style="color: #079e3e; font-size: 12px">
              <span v-if="segment == 'Options'">
                {{ selectedRecommendation.target_premium ? '₹ ' + selectedRecommendation.target_premium : '' }}
              </span>
              <span v-else>
                {{ selectedRecommendation.target_price ? '₹ ' + selectedRecommendation.target_price : '' }}
              </span>
            </div>
            <div class="input-label-gray-small" v-if="selectedRecommendation.status == 'TARGET_ACHIEVED' || selectedRecommendation.reco_status == 'TARGET ACHIEVED'">{{ targetDateTime | filterTime }},</div>
            <div class="input-label-gray-small">
              {{ targetDateTime | formatDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import NewCircleProgress from './NewCircularProgress';
import { filterCallBack } from '../mixins/filter';
import Timer from './Timer';
import ComparedRecommendationsOfExpert from './ComparedRecommendationsOfExpert';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { screenSize } from '../mixins/ScreenSize.js';
import PremiumLock from './LockForPremiumPlan.vue';
import moment from 'moment';
import { EventBus } from '../eventBus';
import { tradeCallback } from '../mixins/tradeMixin';

export default {
  name: 'StockProgressBarComponent',

  mixins: [filterCallBack, HelperNetworkCallBack, screenSize, tradeCallback],

  components: {
    NewCircleProgress,
    Timer,
    ComparedRecommendationsOfExpert,
    PremiumLock,
  },
  props: ['stockData', 'selectedIndex', 'strategyData', 'segment'],

  data() {
    return {
      moment: moment,
      serverHostName: serverHostName,
      websiteUserType: {},
      currentEnvironment: {},
      performance_dialogue_visible: false,
      selectedRecommendation: {},
      progressBarLoading: false,
      stopLoss: null,
      entryPremium: null,
      targetPrice: null,
      currentPrice: null,
      entryDateTime: '',
      cmpDateTime: '',
      targetDateTime: '',

      // new keys
      profitDiv: null,
      lossDiv: null,
      cmpPosition: null,
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
    };
  },

  watch: {},

  mounted() {
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }

    this.showRecommendationPopup(this.stockData);
  },

  methods: {
    calculateBrokerageData() {
      this.selectedRecommendation.brokerage_loader = true;
      var obj = {
        strategy_id: this.selectedRecommendation.strategy_id,
        leg_id: this.selectedRecommendation.id,
        quantity: this.selectedRecommendation.lot_quantity,
      };

      if (this.userProfile.utm_source == 'GCL') {
        obj.buy_brokerage = this.selectedRecommendation.brokerage_data.buy_brokerage ? Number(this.selectedRecommendation.brokerage_data.buy_brokerage) : 0;
        obj.sell_brokerage = this.selectedRecommendation.brokerage_data.sell_brokerage ? Number(this.selectedRecommendation.brokerage_data.sell_brokerage) : 0;
      }

      serverAddr
        .post('options/option_brokerage_calculator', obj)
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data.brokarage_calc;
            var received_data = data.filter((e) => {
              return e.leg_id == this.selectedRecommendation.id;
            })[0];

            this.selectedRecommendation.brokerage_data = received_data.fixed_brokarage_calc;
            this.selectedRecommendation.exp_tax = received_data.exp_tax;

            // to send data to options card component
            var strategy_data = {
              strategy_id: this.selectedRecommendation.strategy_id,
              strategy_level_brokerage: response.data.data.strategy_level_brokerage,
            };

            this.$emit('strategyBrokerage', strategy_data);
          }
          setTimeout(() => {
            this.selectedRecommendation.brokerage_loader = false;
          }, 200);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClose() {
      this.performance_dialogue_visible = false;
      this.clearBarFields();
    },
    addCommonStyling() {
      // if (this.profitDiv) {
      //   this.profitDiv.style.display = "block";
      // }
    },
    showRecommendationPopup(object) {
      this.selectedRecommendation = object;
      this.progressBarLoading = true;

      setTimeout(() => {
        this.profitDiv = document.getElementById(`profit${this.selectedRecommendation.id}`);
        this.lossDiv = document.getElementById(`loss${this.selectedRecommendation.id}`);
        this.cmpPosition = document.getElementById(`cmp-position${this.selectedRecommendation.id}`);

        // this.addCommonStyling();
        if (this.segment == 'Options') {
          this.entryPremium = this.selectedRecommendation.entry_premium;
          this.selectedRecommendation.reco = this.selectedRecommendation.direction;
          this.targetPrice = this.selectedRecommendation.target_premium;

          this.entryDateTime = this.selectedRecommendation.created_date;
          this.targetDateTime = this.selectedRecommendation.result_timestamp;
        } else {
          this.entryDateTime = this.selectedRecommendation.created_at;
          this.targetDateTime = this.selectedRecommendation.result_date_time;

          this.entryPremium = this.selectedRecommendation.reco_open_price;
          this.targetPrice = this.selectedRecommendation.target_price;
        }

        // Define the recommendation values (e.g., stop loss, entry premium, and target price)
        this.stopLoss = this.selectedRecommendation.stop_loss;
        this.currentPrice = this.getCurrentPrice();

        this.calculateRecommendation(object);

        this.progressBarLoading = false;
      }, 300);
    },

    getCurrentPrice() {
      if (this.segment == 'Options') {
        if (this.selectedRecommendation.status == 'LIVE' || this.selectedRecommendation.status == 'UPDATED' || this.selectedRecommendation.status == 'EXIT_AND_REENTRY') {
          this.cmpDateTime = this.selectedRecommendation.stock.last_traded_timestamp;
          return this.selectedRecommendation.current_premium;
        } else if (this.selectedRecommendation.status == 'TARGET_NOT_ACHIEVED' || this.selectedRecommendation.status == 'STOPPED' || this.selectedRecommendation.status == 'EXIT') {
          this.cmpDateTime = this.selectedRecommendation.last_event_timestamp;
          return this.selectedRecommendation.status_action_price;
        } else if (this.selectedRecommendation.status == 'STOPLOSS_TRIGGERED') {
          this.cmpDateTime = this.selectedRecommendation.last_event_timestamp;
          return this.stopLoss;
        } else if (this.selectedRecommendation.status == 'TARGET_ACHIEVED' || this.selectedRecommendation.status == 'COMPLETE') {
          this.cmpDateTime = this.selectedRecommendation.last_event_timestamp;
          this.targetDateTime = this.selectedRecommendation.last_event_timestamp;

          return this.targetPrice;
        }
      } else {
        if (this.selectedRecommendation.reco_status == 'LIVE' || this.selectedRecommendation.reco_status == 'UPDATED') {
          this.cmpDateTime = this.selectedRecommendation.stock.current_datetime;
          return this.selectedRecommendation.stock.current_price;
        } else if (this.selectedRecommendation.reco_status == 'EXIT') {
          this.cmpDateTime = this.selectedRecommendation.exit_date_time;
          return this.selectedRecommendation.exit_price;
        } else if (this.selectedRecommendation.reco_status == 'TARGET NOT ACHIEVED') {
          this.cmpDateTime = this.selectedRecommendation.target_not_achieved_date_time;
          return this.selectedRecommendation.target_not_achieved_price;
        } else if (this.selectedRecommendation.reco_status == 'STOP LOSS TRIGGERED') {
          return this.stopLoss;
        } else if (this.selectedRecommendation.reco_status == 'TARGET ACHIEVED') {
          this.cmpDateTime = this.selectedRecommendation.target_achieved_date_time;
          this.targetDateTime = this.selectedRecommendation.target_achieved_date_time;
          return this.targetPrice;
        }
      }
    },

    calculateRecommendation(object) {
      const lossWidth = 20; // Loss side width percentage
      const profitWidth = 80; // Profit side width percentage
      var cmpRange = null;
      let position;

      // Calculate the performance of the recommendation

      // if status is not yet to live
      if (this.selectedRecommendation.reco_status != 'YET TO LIVE' && this.selectedRecommendation.status != 'YET_TO_LIVE') {
        if (object.reco == 'Buy' || object.reco == 'BUY') {
          this.stopLoss = this.stopLoss != null ? this.stopLoss : this.entryPremium - 10;

          if (this.currentPrice > this.entryPremium) {
            // profit
            cmpRange = this.targetPrice - this.entryPremium;

            position = ((this.currentPrice - this.entryPremium) / cmpRange) * profitWidth;

            position = position > 80 ? 80 : position;

            this.profitDiv.style.width = `${position}%`;

            this.cmpPosition.style.left = `${position + 19}%`;
          } else if (this.currentPrice < this.entryPremium) {
            // loss
            cmpRange = this.entryPremium - this.stopLoss;
            position = ((this.entryPremium - this.currentPrice) / cmpRange) * lossWidth;

            position = position > 20 ? 20 : position;

            if (position >= 18.5) {
              this.lossDiv.style.borderRadius = '6px 0 0 6px';
            }

            this.lossDiv.style.width = `${position}%`;

            this.cmpPosition.style.left = `${19 - position}%`;
          }
        } else if (object.reco == 'Sell' || object.reco == 'SELL') {
          this.stopLoss = this.stopLoss != null ? this.stopLoss : this.entryPremium + 10;
          if (this.currentPrice < this.entryPremium) {
            // profit
            cmpRange = this.targetPrice - this.entryPremium;
            position = ((this.currentPrice - this.entryPremium) / cmpRange) * profitWidth + lossWidth;

            position = position > 80 ? 80 : position;

            this.profitDiv.style.width = `${position}%`;

            this.cmpPosition.style.left = `${position + 19}%`;
          } else if (this.currentPrice > this.entryPremium) {
            // loss
            cmpRange = this.entryPremium - this.stopLoss;
            position = ((this.entryPremium - this.currentPrice) / cmpRange) * lossWidth;

            position = position > 20 ? 20 : position;

            this.lossDiv.style.width = `${position}%`;

            this.cmpPosition.style.left = `${19 - position}%`;
            if (position >= 18.5) {
              this.lossDiv.style.borderRadius = '6px 0 0 6px';
            }
          }
        }
      }
    },

    clearBarFields() {
      this.progressBarLoading = null;
      this.stopLoss = null;
      this.entryPremium = null;
      this.targetPrice = null;
      this.cmpDiv = null;
      this.entryPointDirectionProfit = null;
      this.currentPrice = null;
      this.totalRange = null;
      this.entryPremiumStartPoint = null;
      this.cmpPosition = null;
      this.recommendationPerformance = null;

      // reset progress width
      this.entryPremiumStartDiv.style.width = '0';
      this.progressMovementLossDiv.style.width = `0`;
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.edit-brokerage-input {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-input__inner {
    text-align: center;
    border: none;
    height: 20px;
    line-height: 20px;
    font-size: 11px;
  }

  .el-input--suffix .el-input__inner {
    // padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  .el-input-number .el-input {
    line-height: 20px;
  }
}

// .period-type-tag {
//     text-align: center;
//     border-radius: 8px;
//     padding: 8px 10px 10px;
//     margin: 0 auto;
//     color: #409eff;
//     border: 1px solid;
//     min-width: 50px;
//     font-weight: 600;
//     text-transform: uppercase;
//     font-size: 12px;
//   }

.buy-sell-btn {
  color: #fff !important;
  padding: 2px 7px 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}
.act-period-type-tag:hover,
.act-period-type-tag {
  border-color: #079e3e;
  background-color: #079e3e;
}
.act-period-type-tag-red:hover,
.act-period-type-tag-red {
  border-color: #d60918;
  background-color: #d60918;
}

.performance-dialogue {
  .maxProfitLoss-i {
    position: relative;

    .maxProfitLoss-i-inner {
      position: absolute;
      left: 5px;
      top: -5px;
    }
  }

  .capital-req-box {
    border: 1px solid #ede8e8;
    width: 250px;
    text-align: center;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    font-weight: 600;
  }

  .profit-loss-blocks {
    width: 50%;
    padding: 10px 0;
    text-align: center;
  }

  // .faded-border-bottom {
  //   display: block;
  //   border: none;
  //   color: #fff;
  //   margin-top: 90px;
  //   height: 1px;
  //   background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#ddd), to(#fff));
  // }

  .stock-title {
    font-size: 11px;
  }

  .progress-bar {
    width: 80%;
    background: #e2e2e2;
    height: 10px;
    border-radius: 10px;
    margin: 45px auto 60px;
    position: relative;
    top: 35px;

    #progress-movement-profit {
      position: absolute;
      height: 10px;
      // background: #079e3e;
      text-align: left;
      transition: width 2s;
      transition-timing-function: linear;
      width: 0;
    }

    #progress-movement-loss {
      position: absolute;
      height: 10px;
      text-align: left;
      // transition: width 3s;
      // transition-timing-function: linear;
      background: red;
      top: 36px;
      border-radius: 10px 0 0 10px;
    }

    #entry-point-profit {
      display: block;
      border: 1px solid;
      height: 20px;
      margin-top: -5px;
      width: 0px;
    }

    #cmp-position {
      position: absolute;
      bottom: 2px;
    }

    .inner-progress-bar {
      display: flex;
      // justify-content: space-between;
      // border-bottom: 1px dashed #8a8a8a;
      text-align: center;
      height: 5px;
      margin-bottom: 5px;
      position: relative;

      .input-label-gray {
        font-size: 10px;
      }

      .input-label-gray-small {
        font-size: 8px;
      }

      .left-outer {
        position: absolute;
        left: 0;
        text-align: left;

        .left-point {
          width: 15px;
          background: red;
          height: 10px;
          border-radius: 5px;
        }
      }

      .progress-movement-profit {
        height: 10px;
        background: #079e3e;
        width: 30%;
        text-align: left;
      }

      .entry-point {
        border: 1px solid;
        height: 20px;
        margin-top: -5px;
        width: 0px;
        text-align: left;
      }

      .right-outer {
        position: absolute;
        right: -11px;
        text-align: -webkit-right;

        .right-point {
          width: 15px !important;
          background: #ffff;
          height: 9px;
          border-radius: 5px;
          border: 1px solid #d5d5d5;
          // position: absolute;
          // left: 22px;
        }
      }

      // new css
      .entry-point {
        display: block;
        border: 1px solid;
        height: 20px;
        margin-top: -5px;
        width: 0px;
        position: absolute;
        left: 20%;
      }

      .profit {
        position: absolute;
        left: 20%;
        height: 10px;
        background: #079e3e;
      }

      .loss {
        position: absolute;
        right: 80%;
        height: 10px;
        background: red;
      }
    }

    .top-section {
      position: absolute;
      top: -40px;
      left: 0;
      width: 80px;
      font-size: 8px;
    }
  }

  .progress-bar-inner {
    min-height: 250px;
    background: linear-gradient(360deg, #f3f9ff 0%, #ffffff 69.63%);
  }
}

.performance-dialogue {
  .el-dialog {
    border-radius: 12px;
  }

  .el-dialog__body {
    height: 130px;
  }

  .el-dialog__header {
    padding: 0;
  }
}

@media screen and (max-width: 600px) {
  .performance-dialogue {
    .entry-point-position-mobile {
      position: absolute;
      width: 100px;
      top: 55px;
      left: -15px;
    }

    .progress-bar-inner {
      height: 220px;
    }

    .profit-loss-blocks {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }

    .maxProfitLoss-i .maxProfitLoss-i-inner {
      left: 1px;
    }
  }
}

@media screen and (max-width: 480px) {
  .performance-dialogue {
    .progress-bar-inner {
      height: 235px;
    }
  }
}
</style>
